var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { isNullOrUndefined } from 'util';
import { config } from '../../../config/config';
import { PlaceCategory } from '../constants/constant';
import { FacebookLoginButtonComponent } from './facebook.login.button/facebook.login.button.component';
import { SocialLoginPopupComponent } from './social.login.popup/social.login.popup.component';
import { SubscriptionDisposable } from './subscription.disposable';
import { isInternetExplorer } from '../../utils/broswerCheck';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime } from 'rxjs/operators';
var BaseComponent = /** @class */ (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(componentOptions) {
        if (componentOptions === void 0) { componentOptions = new BaseComponentOption(); }
        var _this = _super.call(this) || this;
        _this.componentOptions = componentOptions;
        _this.mobileMenuTitle = 'More Options';
        _this.isMobile = false;
        _this.isMobileForLargeFeature = false;
        _this.isSmallPC = false;
        _this.isSmallestPC = false;
        _this.isExSmallMobile = false;
        _this.noChangeUrlWhenRedirect = true;
        _this.isIE = false;
        _this.noChangeUrlWhenRedirect = _this.isScriptSolution;
        if (window.location.href.indexOf('localhost:4200') >= 0) {
            _this.noChangeUrlWhenRedirect = false;
        }
        _this.setViews();
        _this.isIE = isInternetExplorer();
        if (componentOptions.activatedRoute) {
            var allParams = componentOptions.activatedRoute.params;
            var parent_1 = componentOptions.activatedRoute.parent;
            var child = componentOptions.activatedRoute.firstChild;
            while (!isNullOrUndefined(child)) {
                allParams = allParams.combineLatest(child.params, function (a, b) { return Object.assign({}, a, b); });
                child = child.firstChild;
            }
            while (!isNullOrUndefined(parent_1)) {
                allParams = allParams.combineLatest(parent_1.params, function (a, b) { return Object.assign({}, a, b); });
                parent_1 = parent_1.parent;
            }
            allParams.takeUntil(_this.isDestroyed).subscribe(function (params) {
                if (params.category) {
                    params.category = PlaceCategory.getPlaceCategoryValue(params.category);
                }
                _this.allRouteParams = params;
            });
        }
        _this.hideSkeleton();
        var resizeObs = fromEvent(window, 'resize');
        resizeObs.pipe(debounceTime(500)).subscribe(function (data) {
            _this.setViews();
        });
        return _this;
    }
    BaseComponent.prototype.setViews = function () {
        this.isMobile = window.innerWidth <= config.phoneSizeWidth;
        this.isSmallPC = window.innerWidth < config.smallPCSizeWidth && !this.isMobile;
        this.isSmallestPC = window.innerWidth <= config.smallestPCSizeWidth && !this.isMobile;
        this.isExSmallMobile = window.innerWidth < config.exSmallphoneSizeWidth;
        // for trip planner
        this.isMobileForLargeFeature = window.innerWidth <= 1360;
    };
    Object.defineProperty(BaseComponent.prototype, "isFacebookLoggedIn", {
        get: function () {
            return FacebookLoginButtonComponent.isUserLoggedWithFacebook;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "isSocialLoggedin", {
        get: function () {
            return SocialLoginPopupComponent.isUserLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseComponent.prototype, "isScriptSolution", {
        get: function () {
            return !!(document.getElementById('imgoingcalendar-wrapper') || document.getElementById('imgoingcalendar-wrapper-wix'));
            // return !config.serverDomain.includes(window.location.hostname) && window.location.hostname !== 'localhost';
        },
        enumerable: true,
        configurable: true
    });
    BaseComponent.prototype.hideSkeleton = function () {
        var wholeSpinner = document.getElementById('skeleton-mask');
        if (wholeSpinner) {
            wholeSpinner.style.display = 'none';
        }
    };
    return BaseComponent;
}(SubscriptionDisposable));
export { BaseComponent };
var BaseComponentOption = /** @class */ (function () {
    function BaseComponentOption() {
    }
    return BaseComponentOption;
}());
export { BaseComponentOption };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/base.component.ts.pre-build-optimizer.js